import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EditTableNameModel } from 'src/app/resy-modul/models/tables/edit-table-name.model';
import { VenueService } from 'src/app/resy-modul/services/venues/venue.service';

@Component({
  selector: 'app-edit-table',
  templateUrl: './edit-table.component.html',
  styleUrls: ['./edit-table.component.scss']
})
export class EditTableComponent implements OnInit {

  tableId: string;
  tableName: string;

  constructor(private ref: DynamicDialogRef,
              private config: DynamicDialogConfig,
              private venueService: VenueService ) { 
      if (config.data != undefined ){
        if (config.data.tableId != undefined){
          this.tableId = config.data.tableId;
        }
        if (config.data.tableName != undefined){
          this.tableName = config.data.tableName;
        }
      }
  }

  ngOnInit(): void {
  }
  
  public editGroup(): void {
    this.ref.close({tableName: this.tableName});
  }

  public close(): void {
    this.ref.close(false);
  }

}
